interface TransitionObserverConfig {
	selector?: string;
}

export const TransitionObserver = {
	elements: [] as unknown as NodeListOf<HTMLElement>,
	observer: null as IntersectionObserver | null,

	init(config?: TransitionObserverConfig): void {
		const selector = config?.selector ?? '.block--has-transition, .block--has-animation';
		this.elements = document.querySelectorAll<HTMLElement>(selector);

		if (!this.elements.length) {
			return;
		}

		this.bindClass();
		this.bindEvents();
	},

	bindClass(): void {
		this.handleIntersect = this.handleIntersect.bind(this);
	},

	bindEvents(): void {
		if (typeof IntersectionObserver === 'undefined') {
			this.elements.forEach((element) => {
				this.revealElement(element);
			});
			return;
		}

		this.observer = new IntersectionObserver(this.handleIntersect, {
			rootMargin: '0px 0px -12% 0px',
			threshold: 0
		});

		this.elements.forEach((el) => {
			this.observer?.observe(el);
		});
	},

	handleIntersect(entries: IntersectionObserverEntry[]): void {
		entries.forEach((entry) => {
			if (!entry.isIntersecting && entry.intersectionRatio <= 0) {
				return;
			}

			this.revealElement(entry.target as HTMLElement);
		});
	},

	revealElement(element: HTMLElement): void {
		element.classList.add('block--in-view');
		this.observer?.unobserve(element);
	}

};
